export const activitiesTabs = [
  { id: 'adults', key: 'activities.tab1', icon: 'ri-user-line' },
  { id: 'kids', key: 'activities.tab2', icon: 'ri-user-smile-line' },
  { id: 'camp', key: 'activities.tab3', icon: 'ri-sun-line' },
  { id: 'coaching', key: 'activities.tab4', icon: 'ri-award-line' },
  { id: 'itf', key: 'activities.tab5', icon: 'ri-trophy-line' },
  { id: 'rental', key: 'activities.tab6', icon: 'ri-calendar-check-line' },
];

export const activitiesContent = {
  adults: {
    items: [
      'activities.adults.item1',
      'activities.adults.item2',
      'activities.adults.item3',
      'activities.adults.item4',
    ],
    image: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/26ca504dca3ea3e996a78d4d03f8ffc0.jpeg',
  },
  kids: {
    items: [
      'activities.kids.item1',
      'activities.kids.item2',
      'activities.kids.item3',
      'activities.kids.item4',
    ],
    image: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/24f41cea917086adfa14c7a896fce52c.jpeg',
  },
  camp: {
    sessions: ['activities.camp.session1', 'activities.camp.session2'],
    activities: [
      'activities.camp.activity1',
      'activities.camp.activity2',
      'activities.camp.activity3',
      'activities.camp.activity4',
      'activities.camp.activity5',
      'activities.camp.activity6',
    ],
    image: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/45329326f7921f3cfa2c869ada885bac.png',
  },
  coaching: {
    items: [
      'activities.coaching.item1',
      'activities.coaching.item2',
      'activities.coaching.item3',
      'activities.coaching.item4',
    ],
    image: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/ddf73352-ddb8-42a4-b40d-2b096201123e_7.jpeg',
  },
  itf: {
    items: [
      'activities.itf.item1',
      'activities.itf.item2',
      'activities.itf.item3',
      'activities.itf.item4',
    ],
    image: 'https://storage.readdy-site.link/project_files/85f4a740-ba4a-41f4-9d5c-84f25b86f483/f12bde40-0ab4-4fd8-854d-12ac56907827_20.jpeg',
  },
  rental: {
    items: [
      'activities.rental.item1',
      'activities.rental.item2',
      'activities.rental.item3',
      'activities.rental.item4',
    ],
    image: 'https://public.readdy.ai/ai/img_res/edited_8863272915e591f51bfd2b179edc9c80_9c99fcf3.jpg',
  },
};